import React, {Fragment} from "react";
import {useNavigate} from "react-router-dom";
import styled from "@emotion/styled";

/*
    props
    options : [{}, {}, ...] = 펼치려는 아이템의 배열 (options.js 참고)
    color : string
    font_size : string
 */
const SpreadItem = (props) => {
    const navigate = useNavigate();

    // css style
    const {view} = useComponentStyle({color: props.color || "#99999", font_size: props.font_size || "1em"});

    return (
        <view.Ul>
            {props.options.map((item, i) => (
                <Fragment key={i}>
                    <li
                        style={{
                            cursor: item.path ? "pointer" : "default",
                        }}
                        onClick={() => {
                            item.path && navigate(item.path);
                        }}>
                        {item.title}
                    </li>
                    {props.options[i + 1] && <li style={{cursor: "default"}}>|</li>}
                </Fragment>
            ))}
        </view.Ul>
    );
};

export default SpreadItem;

export const useComponentStyle = ({color, font_size}) => {
    return {
        view: {
            Ul: styled.ul({
                display: "flex",
                color: color,
                fontSize: font_size || "inherit",
                li: {
                    marginLeft: ".5em",
                },
            }),
        },
    };
};
